<template>
  <div class="configurar-push">
    <v-card class="my-3 pa-3">
      <v-row class="px-3 pb-4">
        <p v-if="showTitle" class="pa-2 title">
          {{ $t('campanhas.notificacao_push') }}
        </p>
        <v-spacer />
        <template-message-modal v-model="selectedTemplate" :disabled="disabled" :mode="['PUSH']" />
        <message-variables />
      </v-row>
      <v-layout wrap>
        <v-flex xs12 md6>
          <div class="outer-frame-push">
            <v-layout justify-center>
              <v-flex xs4>
                <v-layout>
                  <v-spacer />
                  <div class="camera-slot" />
                </v-layout>
              </v-flex>
              <v-flex xs4 class="ear-speaker-slot" />
              <v-flex xs4 />
            </v-layout>
            <div class="inner-frame-push">
              <div class="push-notification d-flex align-center justify-space-between">
                <div :style="getImageUrl ? 'width: calc(100% - 75px)' : 'max-width: 100%'">
                  <div class="application-icon-slot" />
                  <span class="secondary-text push-application-name">{{ $t('campanhas.mercafacil') }}</span>
                  <span class="primary-text push-title" v-html="getRevisedText(pushConfigurationLocal.title)" />
                  <span class="secondary-text push-caption" v-html="getRevisedText(pushConfigurationLocal.text)" />
                </div>
                <img v-if="getImageUrl" class="push-image" :src="getImageUrl" />
              </div>
            </div>
          </div>
        </v-flex>
        <v-flex xs12 md6>
          <div class="form-box">
            <p class="subtitle mf-subtitle-1">
              {{ $t('campanhas.titulo') }}
            </p>
            <v-tooltip top :disabled="!disabled">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <mf-textarea-emoji
                    v-model="pushConfigurationLocal.title"
                    hide-details
                    outlined
                    no-resize
                    background-color="white"
                    height="90"
                    :max-length="48"
                    counter
                    :disabled="disabled"
                    :error-messages="titleErrorMessages"
                  />
                </div>
              </template>
              <span v-if="isMariaCampaignActivated || isMariaCampaignFinished">{{ disabledFieldTooltip }}</span>
              <span v-else>Habilite este canal pela caixa de seleção acima para configurá-lo.</span>
            </v-tooltip>
            <p class="subtitle mf-subtitle-1">
              {{ $t('campanhas.texto_notificacao') }}
            </p>
            <v-tooltip top :disabled="!disabled">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <mf-textarea-emoji
                    v-model="pushConfigurationLocal.text"
                    hide-details
                    outlined
                    no-resize
                    background-color="white"
                    height="120"
                    :max-length="100"
                    counter
                    :disabled="disabled"
                    :error-messages="textErrorMessages"
                  />
                </div>
              </template>
              <span v-if="isMariaCampaignActivated || isMariaCampaignFinished">{{ disabledFieldTooltip }}</span>
              <span v-else>Habilite este canal pela caixa de seleção acima para configurá-lo.</span>
            </v-tooltip>

            <p class="subtitle mf-subtitle-1">Notificação dentro do aplicativo</p>
            <v-tooltip top :disabled="!disabled">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <v-radio-group v-model="pushConfigurationLocal.innerMessage" :disabled="disabled" row>
                    <v-radio key="inicial" label="Utilizar a mesma do push" color="primary" :value="false" />
                    <v-radio key="abrir" label="Escrever mensagem" color="primary" :value="true" />
                  </v-radio-group>
                </div>
              </template>
              <span v-if="isMariaCampaignActivated || isMariaCampaignFinished">{{ disabledFieldTooltip }}</span>
              <span v-else>Habilite este canal pela caixa de seleção acima para configurá-lo.</span>
            </v-tooltip>

            <v-tooltip top :disabled="!disabled">
              <template v-slot:activator="{ on, attrs }">
                <div class="cursor-normal" v-bind="attrs" v-on="on">
                  <mf-toggle v-model="localShowImage" class="mf-toggle mb-4" hide-details :disabled="disabled" label="Imagem na notificação" />
                  <div v-if="localShowImage">
                    <mf-image-cropper
                      :mb-size-limit="0.3"
                      :upload-image="modifyBodyImg"
                      :error-message="messageImageErrorMessages"
                      :url="getImageUrl"
                      :width="400"
                      :height="400"
                      show-hint
                      @remove-image="removeImage"
                      @snackbar="showSnackbar"
                    >
                      <template v-slot:hint-text> (Obs: Alguns dispositivos não exibem imagens push) </template>
                    </mf-image-cropper>
                  </div>
                </div>
              </template>
              <span v-if="isMariaCampaignActivated || isMariaCampaignFinished">{{ disabledFieldTooltip }}</span>
              <span v-else>Habilite este canal pela caixa de seleção acima para configurá-lo.</span>
            </v-tooltip>
          </div>
        </v-flex>
      </v-layout>
    </v-card>

    <v-card v-if="pushConfigurationLocal.innerMessage" class="my-3 pa-3">
      <p class="pa-2 title">
        {{ $t('campanhas.mensagem') }}
      </p>
      <v-layout wrap>
        <v-flex xs12 md6>
          <div class="outer-frame-mensagem">
            <v-layout justify-center>
              <v-flex xs4>
                <v-layout>
                  <v-spacer />
                  <div class="camera-slot" />
                </v-layout>
              </v-flex>
              <v-flex xs4 class="ear-speaker-slot" />
              <v-flex xs4 />
            </v-layout>
            <div class="inner-frame-mensagem">
              <p class="mf-h6">
                {{ pushConfigurationLocal.inner_message_title }}
              </p>
              <p class="mf-subtitle-1">
                {{ pushConfigurationLocal.inner_message_text }}
              </p>
            </div>
            <v-layout justify-center>
              <div class="home-button" />
            </v-layout>
          </div>
        </v-flex>
        <v-flex xs12 md6>
          <div class="form-box">
            <p class="subtitle mf-subtitle-1">{{ $t('campanhas.titulo') }}:</p>
            <mf-textarea-emoji
              v-model="pushConfigurationLocal.inner_message_title"
              hide-details
              outlined
              no-resize
              background-color="white"
              height="90"
              :max-length="50"
              counter
              :disabled="disabled"
              :error-messages="messageTitleErrorMessages"
            />
            <p class="subtitle mf-subtitle-1">{{ $t('campanhas.texto_mensagem') }}:</p>
            <mf-textarea-emoji
              v-model="pushConfigurationLocal.inner_message_text"
              hide-details
              outlined
              no-resize
              :max-length="500"
              background-color="white"
              height="120"
              counter
              :disabled="disabled"
              :error-messages="messageTextErrorMessages"
            />
          </div>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import { textVariables } from '@/mixins/text-variables'
import TemplateMessageModal from '@/components/template-message/TemplateMessageModal.vue'
import { MUTATION_SINGLE_UPLOAD_BASE64 } from '@/graphql'

export default {
  name: 'PushConfiguration',

  components: {
    MessageVariables: () => import('@/modules/campanhas/views/components/edit/MessageVariables.vue'),
    TemplateMessageModal,
  },

  mixins: [textVariables],

  props: {
    campaign: {
      type: Object,
      default: () => {},
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    hasTitleError: {
      type: Boolean,
      default: false,
    },
    hasTextError: {
      type: Boolean,
      default: false,
    },
    hasMessageTitleError: {
      type: Boolean,
      default: false,
    },
    hasMessageTextError: {
      type: Boolean,
      default: false,
    },
    hasImageError: {
      type: Boolean,
      default: false,
    },
    isMariaCampaignActivated: {
      type: Boolean,
      default: false,
    },
    isMariaCampaignFinished: {
      type: Boolean,
      default: false,
    },
    flyerErrorMessages: String,
    pushConfiguration: Object,
    tituloError: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
    showImage: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    dialog: false,
    loading: false,
    selectedTemplate: {},
    modifyDialogBody: false,
  }),

  computed: {
    localShowImage: {
      get() {
        return this.showImage
      },
      set(value) {
        this.$emit('update:showImage', value)
      },
    },
    pushConfigurationLocal: {
      get() {
        return this.pushConfiguration
      },
      set(value) {
        this.$emit('update:pushConfiguration', value)
      },
    },
    titleErrorMessages() {
      if (this.hasTitleError) return 'Insira um título para esta notificação.'
      return ''
    },
    textErrorMessages() {
      if (this.hasTextError) return 'Insira um texto para esta notificação.'
      return ''
    },
    messageTitleErrorMessages() {
      if (this.hasMessageTitleError) return 'Insira um título para esta notificação.'
      return ''
    },

    messageTextErrorMessages() {
      if (this.hasMessageTextError) return 'Insira um texto para esta notificação.'
      return ''
    },
    messageImageErrorMessages() {
      if (this.hasImageError) return 'Selecione uma imagem para esta notificação.'
      return ''
    },
    disabledFieldTooltip() {
      const status = this.isMariaCampaignFinished ? 'concluída' : 'ativa'
      return `Não é possível alterar essa configuração em uma campanha ${status}.`
    },
    getImageUrl() {
      return this.campaign?.image_url ?? this.pushConfigurationLocal?.image_url ?? ''
    },
  },

  watch: {
    innerMessage(val) {
      if (!val) {
        this.pushConfigurationLocal.inner_message_title = ''
        this.pushConfigurationLocal.inner_message_text = ''
      }
    },

    selectedTemplate() {
      this.$emit('update:template-id', this.selectedTemplate._id)
      this.pushConfigurationLocal.text = this.selectedTemplate.message
      this.pushConfigurationLocal.title = this.selectedTemplate.message
    },

    localShowImage(newVal) {
      if (!newVal) this.removeImage()
    },
  },

  methods: {
    async modifyBodyImg({ base64, filename }) {
      await this.$apollo
        .mutate({
          mutation: MUTATION_SINGLE_UPLOAD_BASE64,
          variables: {
            filename,
            base64,
          },
          context: {
            uri: this.$microservicesUrls['upload'],
          },
        })
        .then(({ data: { singleUploadBase64 } }) => {
          const { url } = singleUploadBase64
          if (this.campaign) this.campaign.image_url = url
          else this.pushConfigurationLocal.image_url = url
        })
    },
    removeImage() {
      if (this.disabled) return
      if (this.campaign) this.campaign.image_url = ''
      else this.pushConfigurationLocal.image_url = ''
    },
    showSnackbar(snackbar) {
      this.$snackbar(snackbar)
    },
  },
}
</script>

<style lang="scss">
$phone-size: 600px;
$tablet-size: 960px;

.configurar-push {
  p,
  span {
    max-width: inherit;
    max-height: inherit;
    word-wrap: break-word;
  }
  .outer-frame-push {
    border: 2px solid $cinza-l80;
    border-radius: 40px 40px 0 0;
    border-bottom: 0;
    @media screen and (max-width: $tablet-size) {
      padding: 4vh 3vw;
      margin: 5vh 3vw;
    }
    @media screen and (min-width: $tablet-size) {
      margin: 5vh 3vw 0;
      padding: 4vh 3vw 0;
    }
    height: 48vh;
    .camera-slot {
      border: 2px solid $cinza-l80;
      border-radius: 20px;
      display: inline-block;
      margin-bottom: 5vh;
      height: 2vh;
      width: 2vh;
      margin-right: 0.8vw;
    }
    .ear-speaker-slot {
      border: 2px solid $cinza-l80;
      border-radius: 30px;
      display: inline-block;
      margin-bottom: 5vh;
      height: 2vh;
      width: 10vw;
      margin-left: 0.8vw;
    }
    .inner-frame-push {
      border: 2px solid $cinza-l80;
      border-bottom: 0;
      height: 36vh;
      max-height: 36vh;
      overflow-y: auto;
      .push-notification {
        background-color: $cinza-l90;
        padding: 1.6vw;
        .application-icon-slot {
          background-color: $branco;
          width: 0.8vw;
          height: 0.8vw;
          display: inline-block;
          border-radius: 2px;
        }
        .push-application-name {
          padding-left: 0.8vw;
          font-size: 10px;
          display: inline-block;
        }
        .push-title {
          padding-left: 1.6vw;
          font-size: 20px;
          display: block;
        }
        .push-caption {
          padding-left: 1.6vw;
          font-size: 18px;
          display: block;
        }
      }
    }
  }
  .outer-frame-mensagem {
    border: 2px solid $cinza-l80;
    border-radius: 40px;
    height: 80vh;
    padding: 4vh 4vw;
    margin: 3vw;
    .camera-slot {
      border: 2px solid $cinza-l80;
      border-radius: 20px;
      display: inline-block;
      margin-bottom: 3vh;
      height: 2vh;
      width: 2vh;
      margin-right: 0.8vw;
    }
    .ear-speaker-slot {
      border: 2px solid $cinza-l80;
      border-radius: 30px;
      display: inline-block;
      margin-bottom: 3vh;
      height: 2vh;
      width: 10vw;
      margin-left: 0.8vw;
    }
    .inner-frame-mensagem {
      border: 2px solid $cinza-l80;
      height: 60vh;
      max-height: 60vh;
      overflow-y: auto;
      padding: 2vw;
    }
    .home-button {
      border: 2px solid $cinza-l80;
      border-radius: 40px;
      margin-top: 2vh;
      height: 6vh;
      width: 6vh;
    }
  }
  .subtitle {
    font-weight: normal;
    font-size: 18px;
    color: $cinza-d10;
  }
}
.form-box {
  background-color: $cinza-l90;
  padding: 50px 20px 35px 32px;
  border-radius: 4px;
}
.v-application--is-ltr .v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
  margin-right: 2px;
  margin-top: 5px !important;
}
.v-application--is-ltr .v-textarea.v-text-field--enclosed .v-text-field__slot {
  margin-bottom: 5px;
}

.variable-highlight {
  color: $marca-1;
}

.variable-error {
  color: #d83e3e !important;
}

.variable-error-super {
  .variable-highlight {
    color: $marca-1 !important;
  }
  color: #d83e3e !important;
}

.mf-toggle {
  label {
    color: $cinza-d10 !important;
    font-weight: 700;
    font-size: 16px !important;
    line-height: 1;
  }
}

.cursor-normal {
  cursor: initial !important;
}

.disabled {
  color: $cinza-d10;
}

.push-image {
  width: 60px;
  height: 60px;
}
</style>
